export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 240,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_brandName') || '客户品牌',
    field: 'brandName',
    minWidth: 250,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBrand' },
  },
  {
    title: that.$l('table_label_goodsSize') || '产品尺寸',
    field: 'goodsSize',
    minWidth: 250,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayColor' },
  },
  {
    title: that.$l('table_label_amzSkuStatus') || '产品状态',
    field: 'amzSkuStatus',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_eanCode') || 'EAN条码',
    field: 'eanCode',
    minWidth: 135,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyPrice') || '工厂单价',
    field: 'ftyPrice',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'ftyPrice' },
  },
  {
    title: that.$l('table_label_scmName') || '工厂名称',
    field: 'scmName',
    minWidth: 230,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' },
  },
  {
    title: that.$l('table_label_displayUnit') || '单品包装长(cm)',
    field: 'unitLength',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayUnit' },
  },
  {
    title: that.$l('table_label_goodsProperties') || '产品属性',
    field: 'goodsProperties',
    minWidth: 80,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_specInUnitQty') || '单品规格入数',
    field: 'specInUnitQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayBox') || '纸箱长(cm)',
    field: 'ctnLength',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBox' },
  },
  {
    title: that.$l('table_label_creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
